/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Eyebrow_Pain_EditInputs */

const en_us2_profile_editors_eyebrow_pain_edit = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pain and injuries · edit`)
};

const pt_br2_profile_editors_eyebrow_pain_edit = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dores e lesões · editar`)
};

const es_419_profile_editors_eyebrow_pain_edit = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolores y lesiones · editar`)
};

const pt_pt2_profile_editors_eyebrow_pain_edit = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dores e lesões · editar`)
};

const fr_fr2_profile_editors_eyebrow_pain_edit = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douleurs et blessures · modifier`)
};

const de_de2_profile_editors_eyebrow_pain_edit = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schmerzen und Verletzungen · bearbeiten`)
};

const it_it2_profile_editors_eyebrow_pain_edit = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolori e infortuni · modifica`)
};

/**
* | output |
* | --- |
* | "Pain and injuries · edit" |
*
* @param {Profile_Editors_Eyebrow_Pain_EditInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_eyebrow_pain_edit = /** @type {((inputs?: Profile_Editors_Eyebrow_Pain_EditInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Eyebrow_Pain_EditInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_eyebrow_pain_edit(inputs)
	if (locale === "es-419") return es_419_profile_editors_eyebrow_pain_edit(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_eyebrow_pain_edit(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_eyebrow_pain_edit(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_eyebrow_pain_edit(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_eyebrow_pain_edit(inputs)
	return en_us2_profile_editors_eyebrow_pain_edit(inputs)
});
export { profile_editors_eyebrow_pain_edit as "profile-editors.eyebrow_pain_edit" }